/**
 * Australian company numbers, shown the way the ABR and ASIC print them.
 *
 *   ABN  11 digits  ->  99 006 164 709   (2 3 3 3)
 *   ACN   9 digits  ->     006 164 709   (3 3 3)
 *
 * Used both while someone types and when a stored value is displayed, so a
 * number entered before this existed still reads correctly on screen. What is
 * saved keeps the spaces, which is how the CRM already stores mobiles.
 */

const ABN_DIGITS = 11;
const ACN_DIGITS = 9;

export function formatAbn(raw: string | null | undefined): string {
    const digits = (raw ?? "").replace(/\D/g, "").slice(0, ABN_DIGITS);
    if (digits.length <= 2) return digits;
    const rest = digits.slice(2).match(/.{1,3}/g) ?? [];
    return [digits.slice(0, 2), ...rest].join(" ");
}

export function formatAcn(raw: string | null | undefined): string {
    const digits = (raw ?? "").replace(/\D/g, "").slice(0, ACN_DIGITS);
    return digits.match(/.{1,3}/g)?.join(" ") ?? digits;
}

/** Blank stays blank, so an empty field does not show a dash-less gap. */
export const displayAbn = (raw: string | null | undefined) => (raw ? formatAbn(raw) : "");
export const displayAcn = (raw: string | null | undefined) => (raw ? formatAcn(raw) : "");

export const ABN_INPUT_MAX_LEN = 14; // 11 digits + 3 spaces
export const ACN_INPUT_MAX_LEN = 11; // 9 digits + 2 spaces
